module.exports = __webpack_public_path__ + "img/11i.561bc41d.png";